import { FC } from 'react'
import { FileUploadInput } from '@app/page/src/components/util/SettingsUtil'
import { Stack } from '@dtx-company/design-system/src'
import { exceedsMaxFileSize } from '@dtx-company/shared-components/src/components/organisms/ImageEdit/utils'
import { logoUrlForType } from '../../../../../utils/main'
import { sendErrorNotification } from '@dtx-company/inter-app/src/utils/notifications'
import Image from 'next/image'

interface IconEditorProps {
  provider: string
  imageUrl?: string
  setImage: (imageUrl: string) => void
  featured: boolean
}

export const IconEditor: FC<IconEditorProps> = ({ provider, imageUrl, setImage }) => {
  const hasImageUrl = imageUrl && imageUrl.length > 0
  const handleImageUpload = (e: File): void => {
    const stagedImage = e
    if (stagedImage) {
      if (exceedsMaxFileSize(stagedImage.size)) {
        sendErrorNotification('Image is too large to upload (size limit 10MB)')
      } else {
        setImage(URL.createObjectURL(stagedImage))
      }
    }
  }

  return (
    <Stack direction="row" gap={2}>
      <Image
        alt=""
        src={hasImageUrl ? imageUrl : logoUrlForType(provider)}
        width={55}
        height={55}
        style={{ objectFit: 'cover' }}
      />

      <FileUploadInput handleUpload={handleImageUpload} accept="image/png, image/jpeg" />
    </Stack>
  )
}
